// libs
import { useState } from "react";

// constants
import { APP_VERSION } from "../constants/appUpdates";

export default function useVersion() {
  const [localVersion, setLocalVersion] = useState(
    +localStorage.getItem("version") ?? APP_VERSION,
  );

  const isAppUpdated = localVersion < APP_VERSION;

  const updateVersion = () => {
    localStorage.setItem("version", APP_VERSION);
    setLocalVersion(APP_VERSION);
  };

  return { isAppUpdated, updateVersion };
}
